import React, { useState } from 'react';
import PageHeader from '../components/PageHeader';
import { applyAsVolunteer } from '../services/api';

const PROVINCES = [
  'Eastern Cape', 'Free State', 'Gauteng', 'KwaZulu-Natal', 'Limpopo',
  'Mpumalanga', 'North West', 'Northern Cape', 'Western Cape',
];

export default function Volunteer() {
  const [form, setForm] = useState({ fullName: '', email: '', phoneNumber: '', province: '', motivation: '' });
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus(null);
    try {
      await applyAsVolunteer(form);
      setStatus('success');
      setForm({ fullName: '', email: '', phoneNumber: '', province: '', motivation: '' });
    } catch (err) {
      setStatus('error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <PageHeader
        eyebrow="Volunteer Programme"
        title="Join Our Volunteer Network"
        subtitle="Help us extend workers' rights education and support to every corner of South Africa."
      />
      <section className="section">
        <div className="container" style={{ maxWidth: 640 }}>
          <div className="card">
            {status === 'success' && <div className="success-box">Thank you — your application has been received. We'll be in touch.</div>}
            {status === 'error' && <p className="error-text">Something went wrong. Please try again.</p>}

            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Full Name</label>
                <input name="fullName" required value={form.fullName} onChange={handleChange} />
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>Email</label>
                  <input type="email" name="email" required value={form.email} onChange={handleChange} />
                </div>
                <div className="form-group">
                  <label>Phone Number</label>
                  <input name="phoneNumber" required value={form.phoneNumber} onChange={handleChange} />
                </div>
              </div>
              <div className="form-group">
                <label>Province</label>
                <select name="province" required value={form.province} onChange={handleChange}>
                  <option value="">Select your province</option>
                  {PROVINCES.map((p) => <option key={p} value={p}>{p}</option>)}
                </select>
              </div>
              <div className="form-group">
                <label>Why do you want to volunteer with us?</label>
                <textarea name="motivation" rows="4" value={form.motivation} onChange={handleChange} />
              </div>
              <button type="submit" className="btn btn-gold btn-block" disabled={loading}>
                {loading ? 'Submitting...' : 'Submit Application'}
              </button>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
}
